import { Component, ViewContainerRef } from '@angular/core';
import { Customer, CustomerProfiling } from '../../models/customer/customer-model';
import { ReportService } from '../../services/report/report.service';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { RolePermissionService } from '../../services/role/role-permission.service';
import { Router, Data } from '@angular/router';
import { UtilitiesService } from '../../services/shared/utilities.service';
@Component({
  selector: 'app-rpt-search-history',
  templateUrl: './rpt-search-history.component.html',
  styleUrls: ['./rpt-search-history.component.css']
})
/** rpt-search-history component*/
export class RptSearchHistoryComponent {
  /** rpt-search-history ctor */
  public toDate: string;
  public fromDate: string;
  public searchList: CustomerProfiling[] = [];
  public rowsPerPage: number;
  public pagenumber: number;
  public totalRecord: number;
  public arrRowsPerPage: number[] = [];
  minDate: Date;
  stminDate: Data;
  public isGenrate: boolean = true;
  constructor(private readonly reportService: ReportService, private readonly toastr: ToastsManager, vcr: ViewContainerRef, private readonly router: Router,
    private readonly rolePermissionService: RolePermissionService, private utilityService: UtilitiesService) {
    this.rowsPerPage = 100;
    this.totalRecord = 0;
    this.pagenumber = 0;
    //this.onSubmit();

  }
  selectToDate(e) {
    if (e != null) {
      this.toDate = e;
    }
  }
  selectFromDate(e) {
    if (e != null) {
      this.fromDate = e;
      this.minDate = e;
      this.stminDate = new Date(this.minDate);
    }
  }
  PageChanged($event) {
    this.pagenumber = ($event.page) - 1;
    this.rowsPerPage = $event.itemsPerPage;

    this.onSubmitLoad();
  }
  onSubmit() {
    this.pagenumber = 0;
    this.onSubmitLoad();
  }
  onSubmitLoad() {
    this.isGenrate = false;
    this.toDate = this.utilityService.formatDate(this.toDate);
    this.fromDate = this.utilityService.formatDate(this.fromDate);

    if (this.toDate == "" && this.fromDate == "") {
      this.toastr.info('Please Select any Date', 'Info!');
    }
    if (this.rowsPerPage == undefined) {
      this.rowsPerPage = 100;
    }
    else {
      this.reportService.SearchHistoryReport(this.toDate, this.fromDate, this.pagenumber, this.rowsPerPage).subscribe(
        data => {
          if (data)
          this.isGenrate = true;
          this.searchList = data;
          if (this.searchList[0] != null) {
            this.totalRecord = this.searchList[0].totalRecords;
          }
        });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/Reports/rpt-search-history/rpt-search-history.component.ts